/**
 * An initiative accepts newly-attached Hermes sessions until its release comms
 * have gone out: it must have been approved into an integration branch, must not
 * have failed, and must not yet have had a Prometheus pre-release. Used by both the
 * Hermes create form (to offer the plan) and the backend (to enforce the gate).
 */
export function initiativeAcceptsAttachments(i) {
    return i.status !== 'failed' && !!i.integrationBranch && !i.prometheusPreReleaseAt;
}
//# sourceMappingURL=athena.js.map